/* eslint-disable */
import React, { Component } from 'react';
import { connect } from 'react-redux'
import { Link } from 'react-router';

import './LeaderboardStats.css';


class LeaderboardStats extends Component {

  renderBoard(stats, title, singular, plural) {
    if (!stats) return;
    let topStats = Object.keys(stats)
      .sort((a, b) => stats[b].stat - stats[a].stat)
      .slice(0, this.props.topN);
    let i = 1;
    let nodes = topStats.map(id => {
      let s = stats[id];
      return (
        <Link key={id} to={s.url}>
        <div className="leaderboard-row">
          <div className="leaderboard-rank">#{i++}</div>
          <div className="leaderboard-name">{s.pretty}</div>
          <div className="leaderboard-stat">{s.stat} {s.stat == 1 ? singular : plural}</div>
        </div>
        </Link>
      );
    });

    return (
      <div className="leaderboard-board">
        <div className="leaderboard-title">
          {title}
        </div>
        <div className="leaderboard-rows">
          {nodes}
        </div>
      </div>
    )
  }

  render() {
    let lb = this.props.leaderboard;
    if (!lb) return;

    return (
      <div className="LeaderboardStats">
        <div className="leaderboards">
          {this.renderBoard(lb.escapes, 'Top INDIVIDUALS with most escapes', 'escape', 'escapes')}
          {this.renderBoard(lb.teamEscapes, 'Top TEAMS with most escapes', 'escape', 'escapes')}
          {this.renderBoard(lb.roomCounts, 'Most popular ROOMS by escape count', 'escape', 'escapes')}
          {this.renderBoard(lb.reviewCounts, 'Rooms with most REVIEWS', 'review', 'reviews')}
        </div>
      </div>
    );
  }
}

export default LeaderboardStats;



/** WEBPACK FOOTER **
 ** ./src/components/partials/LeaderboardStats.js
 **/